module.exports = __webpack_public_path__ + "static/media/collection-bird-02-effect.f45d2321.png";